import React, { useState } from "react";
import trans, { isRTL } from "../../../../utils";

import { useSelector } from "react-redux";
import {
	AltitudeUnit,
	DistanceUnit,
	SpeedUnit,
} from "../../../../JsHelpers/PlatformUnits";
import TrackedSelectedSensorsRows from "./TrackedSelectedSensorRows";
import TrackedSelectedParameters from "./TrackedSelectedParameters";
import Button from "../../../Helpers/Button/Button";

export default function TrackedSelectedSensors({ position, CarSensors }) {
	const inf = useSelector((state) => state.users.user);
	function convertMillisecondsToTime(ms) {
		const totalMinutes = Math.floor(ms / 60000); // Convert ms to minutes
		const hours = Math.floor(totalMinutes / 60);
		const minutes = totalMinutes % 60;
		if (isRTL) {
			return `${hours}س ${minutes}د`;
		} else {
			return `${hours}h ${minutes}m`;
		}
	}
	const [showMore, setShowMore] = useState(false);

	return (
		<>
			{position && (
				<div className="object-selected-sensors">
					<TrackedSelectedSensorsRows
						title={"speed"}
						val={`${SpeedUnit(position?.speed, inf?.attributes?.speedUnit)}`}
						img="baselinespeed"
						position={position}
					/>
					{CarSensors?.fuelSupport && (
						<TrackedSelectedSensorsRows title="fuel" val="N/A" img="Fuel" />
					)}
					{CarSensors?.temperatureSensorSupport && (
						<TrackedSelectedSensorsRows
							title="temperature"
							val="N/A"
							img="Temperature"
							position={position}
						/>
					)}
					{CarSensors?.accSupport && (
						<TrackedSelectedSensorsRows
							title="ignition"
							val="OFF"
							img="Ignition"
							position={position}
						/>
					)}
					{CarSensors?.doorSupport && (
						<TrackedSelectedSensorsRows title="door" val="Closed" img="Door" />
					)}
					{Object.keys(position?.attributes).length !== 0 && (
						<>
							<div className="parameters mb-2">
								<div>{trans("Parameters")}</div>
							</div>
							{Object.entries(position?.attributes || {})
								.slice(0, showMore ? undefined : 5)
								.map(([key, value]) => {
									// Format value based on the key
									let formattedValue;

									if (
										[
											"odometer",
											"totalodometer",
											"distance",
											"totalDistance",
										].includes(key)
									) {
										formattedValue = `${DistanceUnit(
											value,
											inf?.attributes?.distanceUnit,
										)}`;
									} else if (key === "hours") {
										formattedValue = convertMillisecondsToTime(value);
									} else if (typeof value === "boolean") {
										formattedValue = value ? trans("ON") : trans("OFF");
									} else {
										formattedValue = Math.round(value * 10) / 10;
									}

									return (
										<div key={key} className="flex-between display-border p-8">
											<div className="parameter-title">{trans(key)}</div>
											<div>{formattedValue}</div>
										</div>
									);
								})}

							{showMore && (
								<>
									<TrackedSelectedParameters
										name={"protocol"}
										item={position.protocol}
									/>
									{position?.protocol !== "meitrack" ? (
										<TrackedSelectedParameters
											name="network"
											item={position.network ? position.network : "- - - -"}
										/>
									) : (
										<>
											<TrackedSelectedParameters
												name="cell id"
												item={position.network?.cellTowers[0]?.cellId}
											/>
											<TrackedSelectedParameters
												name="location area code"
												item={position.network?.cellTowers[0]?.locationAreaCode}
											/>
											<TrackedSelectedParameters
												name="mobile country code"
												item={position.network?.cellTowers[0]?.mobileCountryCode}
											/>
											<TrackedSelectedParameters
												name="mobile network code"
												item={position.network?.cellTowers[0]?.mobileNetworkCode}
											/>
											<TrackedSelectedParameters
												name="signal strength"
												item={position.network?.cellTowers[0]?.signalStrength}
											/>
											<TrackedSelectedParameters
												name="consider ip"
												item={
													position.network?.considerIp === true
														? trans("ON")
														: trans("False")
												}
											/>
											<TrackedSelectedParameters
												name="radio type"
												item={position.network?.radioType}
											/>
										</>
									)}
									<TrackedSelectedParameters
										name="valid"
										item={position.valid ? trans("True") : trans("False")}
									/>
									<TrackedSelectedParameters
										name="outdated"
										item={position.outdated ? trans("True") : trans("False")}
									/>
									<TrackedSelectedParameters
										name="latitude"
										item={position.latitude}
									/>
									<TrackedSelectedParameters
										name="longitude"
										item={position.longitude}
									/>
									<TrackedSelectedParameters
										name="altitude"
										item={AltitudeUnit(
											position.altitude,
											inf?.attributes.altitudeUnit,
										)}
									/>
									<TrackedSelectedParameters
										name="device time"
										item={position.deviceTime}
										type="date"
									/>
									<TrackedSelectedParameters
										name="fix time"
										item={position.fixTime}
										type="date"
									/>
									<TrackedSelectedParameters
										name="server time"
										item={position.serverTime}
										type="date"
									/>
								</>
							)}
							<Button
								text={!showMore ? trans("More") : trans("Less")}
								className="default"
								style={{ margin: "auto", display: "flex", marginTop: "14px" }}
								onClick={() => setShowMore(!showMore)}
							/>
						</>
					)}
				</div>
			)}
		</>
	);
}
